'use strict';

angular.module('app.notificationScreenshot')

.config(['$stateProvider', '$urlRouterProvider', function($stateProvider) {
        $stateProvider.state('notificationview', {
                url: '/notificationview/:report_id/:project_id/:period',
                templateUrl: 'app/notification/notificationScreenshot/notificationScreenshot.html?app_v=deployDate',
                data: {
                    authorizedRoles: []
                },
                controller: 'notificationProjectScreenshotCtrl',
                params: {
                    project_id: null,
                    period: null,
                    report_id: null
                }
            })
}])